/**
 * swiper Data
 */

const swiper =[
    {
        id:1,
        img:'assets/images/small/img-12.jpg',
        title:"Bootstrap"
    },
    {
        id:2,
        img:'assets/images/small/img-11.jpg',
        title:"Website"
    },
    {
        id:3,
        img:'assets/images/small/img-10.jpg',
        title:"Responsive"
    },
    {
        id:4,
        img:'assets/images/small/img-9.jpg',
        title:"Design"
    },
    {
        id:5,
        img:'assets/images/small/img-8.jpg',
        title:"eCommerce"
    },
    {
        id:6,
        img:'assets/images/small/img-7.jpg',
        title:"Templates"
    },
    {
        id:7,
        img:'assets/images/small/img-6.jpg',
        title:"Admin Panel"
    },
    {
        id:8,
        img:'assets/images/small/img-5.jpg',
        title:"Simple"
    },
    {
        id:9,
        img:'assets/images/small/img-4.jpg',
        title:"Dark"
    },
  ]
  
  /**
   * Gallery Data
   */
  const gallery = [
    {
        id:1,
        img:'assets/images/small/img-1.jpg',
        title:"Glasses and laptop from above",
        auther:"Ron Mackie",
        likes:"2.2K",
        comments:"1.3K"
    },
    {
        id:2,
        img:'assets/images/small/img-2.jpg',
        title:"Working at a coffee shop",
        auther:"Nancy Martino",
        likes:"2.2K",
        comments:"1.3K"
    },
    {
        id:3,
        img:'assets/images/small/img-3.jpg',
        title:"Photo was taken in Beach",
        auther:"Elwood Arter",
        likes:"2.2K",
        comments:"1.3K"
    },
    {
        id:4,
        img:'assets/images/small/img-4.jpg',
        title:"Drawing a sketch",
        auther:"Jason McQuaid",
        likes:"2.2K",
        comments:"1.3K"
    },
    {
        id:5,
        img:'assets/images/small/img-4.jpg',
        title:"Working from home little spot",
        auther:"Henry Baird",
        likes:"2.2K",
        comments:"1.3K"
    },
    {
        id:6,
        img:'assets/images/small/img-5.jpg',
        title:"Glasses and laptop from above",
        auther:"Erica Kernan",
        likes:"2.2K",
        comments:"1.3K"
    },
    {
        id:7,
        img:'assets/images/small/img-6.jpg',
        title:"Sunrise above a beach",
        auther:"James Ballard",
        likes:"2.2K",
        comments:"1.3K"
    },
    {
        id:8,
        img:'assets/images/small/img-7.jpg',
        title:"Project discussion with team",
        auther:"Ruby Griffin",
        likes:"2.2K",
        comments:"1.3K"
    },
    {
        id:9,
        img:'assets/images/small/img-8.jpg',
        title:"Dramatic clouds at the Golden Gate Bridge",
        auther:"Ron Mackie",
        likes:"2.2K",
        comments:"1.3K"
    },
    {
        id:10,
        img:'assets/images/small/img-9.jpg',
        title:"Fun day at the Hill Station",
        auther:"Henry Baird",
        likes:"2.2K",
        comments:"1.3K"
    },
    {
        id:11,
        img:'assets/images/small/img-10.jpg',
        title:"Cycling in the countryside",
        auther:"Nancy Martino",
        likes:"2.2K",
        comments:"1.3K"
    },
    {
        id:12,
        img:'assets/images/small/img-11.jpg',
        title:"A mix of friends and strangers heading off to find an adventure.",
        auther:"Erica Kernan",
        likes:"2.2K",
        comments:"1.3K"
    },
  ]
  
  
  /**
   * New Data
   */
  const news =[
    {
        id:1,
        img:'assets/images/small/img-1.jpg',
        badgeClass:"success",
        badgeText:"Business",
        title:"A mix of friends and strangers heading off to find an adventure",
        auther:"James Ballard",
        date:"23 Nov, 2021"
    },
    {
        id:2,
        img:'assets/images/small/img-2.jpg',
        badgeClass:"warning",
        badgeText:"Development",
        title:"How to get creative in your work ?",
        auther:"Ruby Griffin",
        date:"23 Nov, 2021"
    },
    {
        id:3,
        img:'assets/images/small/img-3.jpg',
        badgeClass:"info",
        badgeText:"Fashion",
        title:"How to become a best sale marketer in a year!",
        auther:"Elwood Arter",
        date:"23 Nov, 2021"
    },
    {
        id:4,
        img:'assets/images/small/img-4.jpg',
        badgeClass:"primary",
        badgeText:"Product",
        title:"Manage white space in responsive layouts ?",
        auther:"Nancy Martino",
        date:"23 Nov, 2021"
    },
    {
        id:5,
        img:'assets/images/small/img-5.jpg',
        badgeClass:"success",
        badgeText:"Business",
        title:"Stack designer Olivia Murphy offers freelancing advice",
        auther:"Erica Kernan",
        date:"11 Nov, 2021"
    },
    {
        id:6,
        img:'assets/images/small/img-6.jpg',
        badgeClass:"danger",
        badgeText:"Design",
        title:"A day in the of a professional fashion designer",
        auther:"Jason McQuaid",
        date:"14 Nov, 2021"
    },
    {
        id:7,
        img:'assets/images/small/img-7.jpg',
        badgeClass:"danger",
        badgeText:"Design",
        title:"Design your apps in your own way",
        auther:"Henry Baird",
        date:"19 Nov, 2021"
    },
    {
        id:8,
        img:'assets/images/small/img-8.jpg',
        badgeClass:"warning",
        badgeText:"Development",
        title:"How apps is changing the IT world",
        auther:"Elwood Arter",
        date:"10 Aug, 2021"
    },
  ]
  
  /**
   * Video Data
   */
  const video=[
    {
        id:1,
        title:"Admin dashboard templates - Material Design for Utelize",
        siteLink:"https://themesbrand.com/velzon/index.html",
        videoLink : "https://www.youtube.com/embed/GfSZtaoc5bw",
        description :"Utelize admin is super flexible, powerful, clean, modern & responsive admin template based on bootstrap 5 stable with unlimited possibilities. You can simply change to any layout or mode by changing a couple of lines of code. You can start small and large projects or update design in your existing project using Utelize it is very quick and easy as it is beautiful, adroit, and delivers the ultimate user experience.",
        likes:335,
        comments:102,
        auther :"Themesbrand"
    },
    {
        id:2,
        title:"Create Responsive Admin Dashboard using Html CSS",
        siteLink:"https://themesbrand.com/velzon/index.html",
        videoLink : "https://www.youtube.com/embed/Z-fV2lGKnnU",
        description :"Utelize admin is super flexible, powerful, clean, modern & responsive admin template based on bootstrap 5 stable with unlimited possibilities. You can simply change to any layout or mode by changing a couple of lines of code. You can start small and large projects or update design in your existing project using Utelize it is very quick and easy as it is beautiful, adroit, and delivers the ultimate user experience.",
        likes:485,
        comments:167,
        auther :"Themesbrand"
    },
    {
        id:3,
        title:"Utelize - The Most Popular Bootstrap 5 HTML, Angular & React Js Admin",
        siteLink:"https://themesbrand.com/velzon/index.html",
        videoLink : "https://www.youtube.com/embed/1y_kfWUCFDQ",
        description :"Utelize admin is super flexible, powerful, clean, modern & responsive admin template based on bootstrap 5 stable with unlimited possibilities. You can simply change to any layout or mode by changing a couple of lines of code. You can start small and large projects or update design in your existing project using Utelize it is very quick and easy as it is beautiful, adroit, and delivers the ultimate user experience.",
        likes:122,
        comments:51,
        auther :"Themesbrand"
    }
  ]
  
  export { swiper, gallery, news, video };
  